import React from 'react';
import './index.css';

function Spinner({ big, dark }) {
    return (

        <div className={ ` ${big && 'big'} ${dark && 'dark'} spinnerHolder alignOnly ml-1 center` }>
            <div className="spinner"></div>
        </div>
    )
}

export default Spinner;
